export const filesActions = {
    GET_BUILD_REPORT_FILE : 'GET_BUILD_REPORT_FILE',
    RECEIVE_BUILD_REPORT_FILE : 'RECEIVE_BUILD_REPORT_FILE',
    DOWNLOAD_BUILD_SCRIPT : 'DOWNLOAD_BUILD_SCRIPT'
};

const initState = {};

export const filesReducer = (state = initState, action: any) => {
    switch (action.type) {
        case filesActions.RECEIVE_BUILD_REPORT_FILE:
            return state;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/filesReducer.ts